import { defineSseEvent } from '@terra/shared-sse-contracts';
import { z } from 'zod';

export const APPLICATION_SCOPE_LIFECYCLE_RECONCILED_SSE_TYPE =
  'APPLICATION_SCOPE_LIFECYCLE_RECONCILED' as const;

export const ApplicationScopeLifecycleReconciledSsePayloadSchema = z.object({
  applicationId: z.string(),
  archivedCount: z.number().int().nonnegative(),
  activatedCount: z.number().int().nonnegative(),
  healedChildCount: z.number().int().nonnegative(),
});

export const APPLICATION_SCOPE_LIFECYCLE_RECONCILED_SSE_EVENT = defineSseEvent({
  type: APPLICATION_SCOPE_LIFECYCLE_RECONCILED_SSE_TYPE,
  payload: ApplicationScopeLifecycleReconciledSsePayloadSchema,
  channelPrefix: 'application-scope-lifecycle',
  channelKey: ({ applicationId }) => applicationId,
  target: {
    type: () => 'WEB_APPLICATION',
    id: ({ applicationId }) => applicationId,
  },
});

export type ApplicationScopeLifecycleReconciledSsePayload = z.infer<
  typeof ApplicationScopeLifecycleReconciledSsePayloadSchema
>;
